export enum ReplacementTransportMode {
  none = 'none',
  taxi = 'taxi',
  ownCar = 'ownCar',
  other = 'other',
}
